import { __assign, __rest } from "tslib";
import React from "react";
// TODO hasError prop for red borders
export var Input = React.forwardRef(function (_a, ref) {
    var className = _a.className, _b = _a.type, type = _b === void 0 ? "text" : _b, inputProps = __rest(_a, ["className", "type"]);
    return (React.createElement("input", __assign({ type: type, className: "w-full border-gray-300 border rounded-sm p-1 text-xl " + className, ref: ref, "data-testid": "input" }, inputProps)));
});
//# sourceMappingURL=Input.js.map